import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { CouponModalStyle } from "./CouponModal.styled";
import Button from "react-bootstrap/Button";
import { CouponSchmea } from "../../validations/CouponValidation";
import { v4 as uuidv4 } from "uuid";
import { useDB } from "../../context/DynamoDBContext";
import moment from "moment";
import { toast } from "react-toastify";
import { downloadCouponReports } from "../../common/DownloadCoupons";
import { getMonthString } from "../../common/ConvertMonth";
import { useQuery } from "@tanstack/react-query";
import { getSubscriptionPlanList } from "../../api/CouponApi";
import { getSubscriptionString } from "../../common/ConvertSubscription";
import { ModalTitle } from "../../styles/ModalStyles";

const AddCoupons = ({ visible, setVisible }) => {
  const { dynamoDBClient } = useDB();
  const [promotionName, setPromotionName] = useState("");
  const [promoNameError, setPromoNameError] = useState(false);
  const [promoNameErrStatement, setPromoNameErrStatement] = useState("");
  const [code, setCode] = useState(0);
  const [codeError, setCodeError] = useState(false);
  const [codeErrStatement, setCodeErrStatement] = useState("");
  const [expire, setExpire] = useState();
  const [subscriptionPlanList, setSubscriptionPlanList] = useState([]);
  const [selectedSubscription, setSelectedSubscription] = useState("");
  const [enableSubscriptionPlan, setEnableSubscriptionPlan] = useState(false);
  const [expireErr, setExpireErr] = useState(false);
  const [expireStatement, setExpireStatement] = useState("");
  const [disable, setDisable] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [PromoUId, setPromoUId] = useState("");
  const [subscriptionError, setSubscriptionError] = useState(false);
  const [subscriptionErrorStatement, setSubscriptionErrorStatement] =
    useState("");
  const [prefix, setPrefix] = useState("");

  useEffect(() => {
    if (!visible) {
      setPromotionName("");
      setPromoNameError(false);
      setPromoNameErrStatement("");
      setCode(0);
      setCodeError(false);
      setCodeErrStatement("");
      setExpire();
      setExpireErr(false);
      setExpireStatement("");
      setDisable(false);
      setSubscriptionPlanList([]);
      setEnableSubscriptionPlan(false);
      setSelectedSubscription("");
      setSubscriptionError(false);
      setSubscriptionErrorStatement("");
    }
    if (dynamoDBClient && visible) {
      setEnableSubscriptionPlan(true);
    } else {
      setEnableSubscriptionPlan(false);
    }
  }, [visible, dynamoDBClient]);

  const { data: subscriptionList } = useQuery({
    queryKey: ["getSubscriptionPlanList"],
    queryFn: () => getSubscriptionPlanList(dynamoDBClient),
    enabled: enableSubscriptionPlan,
    onSuccess: (data) => {
      if (data.length != 0) {
        setSubscriptionPlanList(data);
      }
      setEnableSubscriptionPlan(false);
    },
    onError: (error) => {
      toast.error("Unable to get Subscription List", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    },
  });

  const rollBack = async (id) => {
    try {
      const params = {
        TableName: "PromoGroup",
        Key: {
          PromoGroupId: id,
        },
      };
      const result = await dynamoDBClient.delete(params).promise();
      const params2 = {
        TableName: "Promocodes",
        Key: {
          PromoGroupId: id,
        },
      };
      const result2 = await dynamoDBClient.delete(params2).promise();
      toast("Roll Back Successfull");
    } catch (error) {
      toast.error("Roll Back Failed", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
      throw new Error();
    }
  };

  const handleApiError = () => {
    setApiError(true);
    toast.error("Error While adding Promo Codes", {
      bodyClassName: "notification-div-error",
      progressClassName: "progress-bar-error",
    });
    toast.error("Rolling Back", {
      bodyClassName: "notification-div-error",
      progressClassName: "progress-bar-error",
    });
    setDisable(false);
    setVisible(false);
    rollBack(PromoUId);
  };

  const GenerateCoupons2 = async () => {
    const codes = [];
    const PromoUniqueId = uuidv4();
    setPromoUId(PromoUniqueId);
    for (let index = 0; index < code; index++) {
      const promoCode = generateRandomCode();

      codes.push(prefix + promoCode.toUpperCase());
    }

    try {
      const params = {
        TableName: "PromoGroup",
        Item: {
          PromoGroupId: PromoUniqueId,
          PromoGroupName: promotionName,
          NumberOfPromos: code,
          Duration: expire,
          SubscriptionId: selectedSubscription,
          DateCreated: `${moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSS")}`,
        },
        ReturnConsumedCapacity: "TOTAL",
      };
      const result = await dynamoDBClient.put(params).promise();

      let count = 0;
      let end = codes.length;
      let end2 = 0;
      let params2 = {
        RequestItems: {
          PromoCodes: [],
        },
      };
      let params3 = [];

      await Promise.all(
        codes.map(async (item) => {
          count++;
          end2++;

          if (count > 25 || end2 == end) {
            count = 1;
            if (end2 == end) {
              params2.RequestItems.PromoCodes.push({
                PutRequest: {
                  Item: {
                    Code: item,
                    DateCreated: `${moment().format(
                      "YYYY-MM-DDTHH:mm:ss.SSSSSS"
                    )}`,
                    Duration: expire,
                    PromoGroupId: PromoUniqueId,
                    IsUsed: "false",
                    PromoStatus: "InActive",
                    SubscriptionId: selectedSubscription,
                  },
                },
              });
            }
            params3.push(params2);

            params2 = {
              RequestItems: {
                PromoCodes: [],
              },
            };
            params2.RequestItems.PromoCodes.push({
              PutRequest: {
                Item: {
                  Code: item,
                  DateCreated: `${moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSSSS"
                  )}`,
                  Duration: expire,
                  PromoGroupId: PromoUniqueId,
                  IsUsed: "false",
                  PromoStatus: "InActive",
                  SubscriptionId: selectedSubscription,
                },
              },
            });
          } else {
            params2.RequestItems.PromoCodes.push({
              PutRequest: {
                Item: {
                  Code: item,
                  DateCreated: `${moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSSSS"
                  )}`,
                  Duration: expire,
                  PromoGroupId: PromoUniqueId,
                  IsUsed: "false",
                  PromoStatus: "InActive",
                  SubscriptionId: selectedSubscription,
                },
              },
            });
          }
        })
      );

      await Promise.all(
        params3.map(async (item) => {
          await new Promise((resolve) => {
            dynamoDBClient.batchWrite(item, (err, data) => {
              if (err) {
                throw new Error();
              } else {
                resolve();
              }
            });
          });
        })
      );
    } catch (error) {
      handleApiError();

      return;
    }

    if (!apiError) {
      toast("Promo Codes added sucessfully");
      downloadCouponReports(
        {
          PromoGroupName: promotionName,
          children: codes,
        },
        true
      );
    }
    setVisible(true);
  };

  function generateRandomCode() {
    return uuidv4().replace(/-/g, "").substring(0, 8);
  }

  const Errors = (err) => {
    err.forEach((element) => {
      switch (element.split(":")[0]) {
        case "1":
          setPromoNameError(true);
          setPromoNameErrStatement(element.split(":")[1]);
          break;
        case "2":
          setExpireErr(true);
          setExpireStatement(element.split(":")[1]);
          break;
        case "3":
          setCodeError(true);
          setCodeErrStatement(element.split(":")[1]);
          break;
        case "4":
          setSubscriptionError(true);
          setSubscriptionErrorStatement(element.split(":")[1]);
          break;
        default:
          // setError(true)
          // setErrorText("An Error has occured")
          break;
      }
    });
  };

  const generateCoupons = async () => {
    setDisable(true);
    const formData = {
      name: promotionName,
      expiry: expire,
      code,
      subscriptionPlan: selectedSubscription,
    };
    await CouponSchmea.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        GenerateCoupons2();
      })
      .catch((err) => {
        setDisable(false);
        Errors(err.errors);
      });
  };

  const expiration = (num) => {
    setExpire(num);
    setExpireErr(false);
  };

  return (
    <Modal
      show={visible}
      onHide={() => setVisible(false)}
      dialogClassName="custom-modal3"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <ModalTitle>Create Promotional Group</ModalTitle>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <CouponModalStyle>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <h6 className="text">Promotional Group* :&ensp; </h6>
                </td>
                <td>
                  <div>
                    <input
                      value={promotionName}
                      onChange={(e) => {
                        setPromotionName(e.target.value);
                        setPromoNameError(false);
                      }}
                      disabled={disable}
                      maxLength={30}
                      placeholder="Enter Group Name"
                      className={
                        promoNameError
                          ? "form-control error-input"
                          : "form-control input-field"
                      }
                    />
                    {promoNameError && (
                      <p className="text-error">{promoNameErrStatement}</p>
                    )}
                  </div>
                </td>
              </tr>
              <tr className="space-div"></tr>
              <tr>
                <td>
                  <h6 className="text">Subscription Plan* :&ensp; </h6>
                </td>
                <td>
                  <div>
                    <div className="dropdown">
                      <button
                        className="btn btn-secondary dropdown-toggle dropDown-custom"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        disabled={disable}
                      >
                        {selectedSubscription != ""
                          ? getSubscriptionString(selectedSubscription)
                          : "Select"}
                      </button>
                      <ul className="dropdown-menu menu2">
                        {subscriptionPlanList.length > 0 ? (
                          subscriptionPlanList.map((data, index) => (
                            <li
                              onClick={() => {
                                const containsNotice =
                                  data.SubscriptionId.indexOf("notice") !== -1;
                                if (containsNotice) {
                                  setPrefix("BA");
                                } else {
                                  setPrefix("NS");
                                }
                                setSelectedSubscription(data.SubscriptionId);
                              }}
                              key={index}
                            >
                              <a className="dropdown-item">
                                {getSubscriptionString(data.SubscriptionId)}
                              </a>
                            </li>
                          ))
                        ) : (
                          <li onClick={() => expiration(1)}>
                            <a className="dropdown-item">No data available</a>
                          </li>
                        )}
                      </ul>
                    </div>
                    {subscriptionError && (
                      <p className="text-error">{subscriptionErrorStatement}</p>
                    )}
                  </div>
                </td>
              </tr>
              <tr className="space-div"></tr>

              <tr>
                <td>
                  <h6 className="text">Duration* :&ensp; </h6>
                </td>
                <td>
                  <div>
                    <div className="dropdown">
                      <button
                        className="btn btn-secondary dropdown-toggle dropDown-custom"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        disabled={disable}
                      >
                        {expire ? getMonthString(expire) : "Select"}
                      </button>
                      <ul className="dropdown-menu menu2">
                        <li onClick={() => expiration(1)}>
                          <a className="dropdown-item">{getMonthString("1")}</a>
                        </li>
                        <li onClick={() => expiration(2)}>
                          <a className="dropdown-item">{getMonthString("2")}</a>
                        </li>
                        <li onClick={() => expiration(3)}>
                          <a className="dropdown-item">{getMonthString("3")}</a>
                        </li>
                        <li onClick={() => expiration(4)}>
                          <a className="dropdown-item">{getMonthString("4")}</a>
                        </li>
                        <li onClick={() => expiration(5)}>
                          <a className="dropdown-item">{getMonthString("5")}</a>
                        </li>
                        <li onClick={() => expiration(6)}>
                          <a className="dropdown-item">{getMonthString("6")}</a>
                        </li>
                        <li onClick={() => expiration(7)}>
                          <a className="dropdown-item">{getMonthString("7")}</a>
                        </li>
                        <li onClick={() => expiration(8)}>
                          <a className="dropdown-item">{getMonthString("8")}</a>
                        </li>
                        <li onClick={() => expiration(9)}>
                          <a className="dropdown-item">{getMonthString("9")}</a>
                        </li>
                        <li onClick={() => expiration(10)}>
                          <a className="dropdown-item">
                            {getMonthString("10")}
                          </a>
                        </li>
                        <li onClick={() => expiration(11)}>
                          <a className="dropdown-item">
                            {getMonthString("11")}
                          </a>
                        </li>
                        <li onClick={() => expiration(12)}>
                          <a className="dropdown-item">
                            {getMonthString("12")}
                          </a>
                        </li>
                      </ul>
                    </div>
                    {expireErr && (
                      <p className="text-error">{expireStatement}</p>
                    )}
                  </div>
                </td>
              </tr>
              <tr className="space-div"></tr>
              <tr>
                <td>
                  <h6 className="text">Number of Promo Codes* :&ensp; </h6>
                </td>
                <td>
                  <div>
                    <input
                      value={code}
                      onChange={(e) => {
                        let str = e.target.value;
                        if (str.startsWith("0")) {
                          str = str.slice(1);
                        }
                        setCode(str);

                        setCodeError(false);
                      }}
                      disabled={disable}
                      placeholder="Enter No of Promo Codes"
                      type="number"
                      className={
                        codeError
                          ? "form-control error-input"
                          : "form-control input-field"
                      }
                    />
                    {codeError && (
                      <p className="text-error">{codeErrStatement}</p>
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </CouponModalStyle>
      </Modal.Body>

      <Modal.Footer>
        <CouponModalStyle>
          <button
            className="btn form-button3"
            disabled={disable}
            onClick={generateCoupons}
          >
            {disable ? "Generating" : "Generate"} &ensp;{" "}
            <i className="bi bi-download"></i>
          </button>
          <Button variant="secondary" onClick={() => setVisible(false)}>
            <p className="bootstrap-btn">Close</p>
          </Button>
        </CouponModalStyle>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCoupons;
